import { useContext, useEffect, useState, useRef } from "react";
import { store } from "./Store";
import { NetworkAPI } from "../services/api/network";
import { useLocation } from "react-router-dom";

const TIMEOUT = 1000 * 19; // 19s
const CHECK_INTERVAL = 1000 * 20; // 20s

const fetchWithTimeout = (timeout = TIMEOUT) => {
	const controller = new AbortController();

	return Promise.race([
		NetworkAPI.checkNetworkStatus({ abortSignal: controller.signal }),
		new Promise((_, reject) =>
			setTimeout(() => {
				controller.abort();
				reject(new Error("timeout"));
			}, timeout)
		),
	]);
};

export const NetworkStatusDetector = ({ children }) => {
	const { dispatch } = useContext(store);
	const [online, setOnline] = useState(undefined);
	const location = useLocation();
	const intervalRef = useRef(null);

	const detectNetwork = async () => {
		try {
			await fetchWithTimeout(TIMEOUT);
			setOnline(true);
		} catch (error) {
			if (error?.message === "offline" || error?.message === "timeout") {
				setOnline(false);
			}
		}
	};

	// Interval solo una vez
	useEffect(() => {
		detectNetwork(); // chequeo inicial

		intervalRef.current = setInterval(() => {
			detectNetwork();
		}, CHECK_INTERVAL);

		return () => {
			if (intervalRef.current) clearInterval(intervalRef.current);
		};
	}, []); // 👈 solo una vez

	// Al cambiar de ruta, ejecuta un chequeo inmediato
	useEffect(() => {
		detectNetwork();
	}, [location.pathname]);

	// Sincronizar estado global
	useEffect(() => {
		dispatch({
			type: "CHANGE_VALUE",
			property: "isOnline",
			value: online,
		});
	}, [online, dispatch]);

	return children;
};
